import type { TrackingStatus } from '../services/websiteService';

export type TrackingStatusLabel = 'Active' | 'Inactive' | 'Not Installed';

/** Aligns with Website Settings: last event within 24h = Active when tracking is active. */
export function getTrackingStatusLabel(
  status: TrackingStatus | null,
  lastEventAt: string | null
): TrackingStatusLabel {
  if (!status) return 'Not Installed';
  if (!status.is_active) return 'Inactive';
  const lastAt = status.last_event_at ?? lastEventAt;
  if (!lastAt) return 'Not Installed';
  const last = new Date(lastAt).getTime();
  const cutoff = Date.now() - 24 * 60 * 60 * 1000;
  return last >= cutoff ? 'Active' : 'Inactive';
}

export function getTrackingStatusBadgeClass(status: TrackingStatusLabel): string {
  if (status === 'Active') return 'bg-emerald-500/20 text-emerald-600 dark:text-emerald-400';
  if (status === 'Inactive') return 'bg-amber-500/20 text-amber-600 dark:text-amber-400';
  return 'bg-red-500/20 text-red-600 dark:text-red-400';
}
